import { useMutation } from '@tanstack/react-query';
import { handleErrorResponse } from '../../utils/handleError';
import { sendOTP } from '../../apis';
import { useLocation, useNavigate } from 'react-router-dom';
import { triggerSnackbar } from '../../provider/SnackbarProvider';
import { AxiosError } from 'axios';

const useSendOTP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mutate, error, isPending, status, isError, isSuccess } = useMutation({
    mutationKey: ['patient-send-otp'],
    mutationFn: sendOTP,
    onSuccess: (data, email) => {
      const { message } = data || {};
      const is_account_already_exist = data?.data?.is_account_already_exist;

      if (is_account_already_exist) {
        navigate('/login', {
          state: {
            email,
          },
        });
      } else {
        navigate('/setup/otp', { state: { email } });
        if (message) {
          triggerSnackbar({ message: message, severity: 'success' });
        }
      }
    },
    onError: (error: AxiosError) => {
      const errorResponse = error?.response;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { message = '' } = (errorResponse?.data as any) || {};

      if (message && message.includes('Already have an account')) {
        navigate('/registered-email');
      } else if (
        !location.pathname.includes('/auth/email-retry') &&
        message &&
        message.includes('Patient account does not exist')
      ) {
        navigate('/auth/email-retry');
      } else {
        handleErrorResponse(error, 'OTP failed');
      }
    },
  });

  const sendOtpRequest = (email: string) => {
    mutate(email);
  };

  return {
    sendOtpRequest,
    isError,
    isSuccess,
    error,
    isPending,
    status,
  };
};

export default useSendOTP;
